export const filingExcemptionHeaderText = "Filing Exemptions";
export const filingExcemptionTileHeaderText =
  "Select the option(s) that best describe your business:";

const cat1 = {
  categoryId: 1,
  categoryTitle: "Large Operating Company",
  selected: false,
  modalResponded: null,
  requiredCount: 6,
  questions: [
    {
      id: 1,
      title: `<span>The entity employs more than 20 full time employees when applying the meaning of full-time employee provided in <a href="https://www.govinfo.gov/content/pkg/CFR-2015-title26-vol19/pdf/CFR-2015-title26-vol19-sec54-4980H-1.pdf" target="_blank">26 CFR 54.4980H-1(a) and 54.4980H-3</a>. In general, “full-time employee” means an employee who is employed for an average of at least 30 hours of service per week within a calendar month. </span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>More than 20 full-time employees of the entity are employed in the “United States,” as that term is defined in <a href="https://www.govinfo.gov/content/pkg/CFR-2015-title26-vol19/pdf/CFR-2015-title26-vol19-sec54-4980H-3.pdf" target="_blank">31 CFR 1010.100(hhh)</a>.</span>`,
      selection: null,
    },
    {
      id: 3,
      title: `<span>The entity has an operating presence at a physical office within the United States. <a target="_blank" href="https://www.govinfo.gov/content/pkg/CFR-2021-title31-vol3/pdf/CFR-2021-title31-vol3-sec1010-100.pdf">“Operating presence at a physical office within the United States”</a> means that an entity regularly conducts its business at a physical location in the United States that the entity owns or leases and that is physically distinct from the place of business of any other unaffiliated entity.</span>`,
      selection: null,
    },
    {
      id: 4,
      title: `<span>The entity filed a Federal income tax or information return in the United States for the previous year demonstrating more than $5,000,000 in gross receipts or sales. If the entity is part of an affiliated group of corporations within the meaning of <a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title26/pdf/USCODE-2021-title26-subtitleA-chap6-subchapA-sec1504.pdf">26 U.S.C. 1504</a>, refer to the consolidated return for such group.</span>`,
      selection: null,
    },
    {
      id: 5,
      title: `<span>The entity reported this greater-than-$5,000,000 amount as gross receipts or sales (net of returns and allowances) on the entity’s IRS Form 1120, <a target="_blank" href="https://www.irs.gov/pub/irs-pdf/f1120.pdf">consolidated IRS Form 1120</a>, <a target="_blank" href="https://www.irs.gov/pub/irs-pdf/f1120s.pdf">IRS Form 1120-S</a>, <a target="_blank" href="https://www.irs.gov/pub/irs-pdf/f1065.pdf">IRS Form 1065</a>, or other applicable IRS form.</span>`,
      selection: null,
    },
    {
      id: 6,
      title: `When gross receipts or sales from sources outside the United States, as determined under Federal income tax principle, are excluded from the entity’s amount of gross receipts or sales, the amount remains greater than $5,000,000.`,
      selection: null,
    },
  ],
};

const cat2 = {
  categoryId: 2,
  categoryTitle: "Inactive Entity",
  selected: false,
  modalResponded: null,
  requiredCount: 6,
  questions: [
    {
      id: 1,
      title: `<span>The entity was <a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2011-title26/pdf/USCODE-2011-title26.pdf">in existence on or before January 1, 2020.</a></span>`,
      selection: null,
    },
    {
      id: 2,
      title: `The entity is not engaged in active business.`,
      selection: null,
    },
    {
      id: 3,
      title: `The entity is not owned by a foreign person, whether directly or indirectly, wholly or partially. “Foreign person” means a person who is not a United States person. A United States person is defined in section 7701(a)(30) of the Internal Revenue Code of 1986 as a citizen or resident of the United States, domestic partnership and corporation, and other estates and trusts.`,
      selection: null,
    },
    {
      id: 4,
      title: `The entity has not experienced any change in ownership in the preceding twelve-month period.`,
      selection: null,
    },
    {
      id: 5,
      title: `The entity has not sent or received any funds in an amount greater than $1,000, either directly or through any financial account in which the entity or any affiliate of the entity had an interest, in the preceding twelve month period.`,
      selection: null,
    },
    {
      id: 6,
      title: `The entity does not otherwise hold any kind or type of assets, whether in the United States or abroad, including any ownership interest in any corporation, limited liability company, or other similar entity.`,
      selection: null,
    },
  ],
};

const cat3 = {
  categoryId: 3,
  categoryTitle: "Accounting Firm",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is a public accounting firm registered in accordance with section 102 of the Sarbanes-Oxley Act of 2002 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap98-subchapI-sec7212.pdf">15 U.S.C. 7212</a>).</span>`,
      selection: null,
    },
  ],
};

const cat4 = {
  categoryId: 4,
  categoryTitle: "Insurance Company",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is an “insurance company” as defined in section 2 of the Investment Company Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapI-sec80a-2.pdf">15 U.S.C. 80a-2</a>).</span>`,
      selection: null,
    },
  ],
};

const cat5 = {
  categoryId: 5,
  categoryTitle: "State-Licensed Insurance Producer",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 1,
      title: `The entity is an insurance producer that is authorized by a State and subject to supervision by the insurance commissioner or a similar official or agency of a State.`,
      selection: null,
    },
    {
      id: 2,
      title: `The entity has an operating presence at a physical office within the United States. The term “operating presence at a physical office within the United States” means that an entity regularly conducts its business at a physical location in the United States that the entity owns or leases and that is physically distinct from the place of business of any other unaffiliated entity.`,
      selection: null,
    },
  ],
};

const cat6 = {
  categoryId: 6,
  categoryTitle: "Tax-Exempt Entity",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is an organization that is described in section 501(c) of the Internal Revenue Code of 1986 (Code) (determined without regard to section 508(a) of the Code) and exempt from tax under <a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2011-title26/pdf/USCODE-2011-title26.pdf">section 501(a)</a> of the Code.</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `The entity is an organization that is described in section 501(c) of the Code, and was exempt from tax under section 501(a) of the Code, but lost its tax-exempt status less than 180 days ago.`,
      selection: null,
    },
    {
      id: 3,
      title: `The entity is a political organization, as defined in section 527(e)(1) of the Code, that is exempt from tax under section 527(a) of the Code.`,
      selection: null,
    },
    {
      id: 4,
      title: `The entity is a trust described in paragraph (1) or (2) of section 4947(a) of the Code.`,
      selection: null,
    },
  ],
};

const cat7 = {
  categoryId: 7,
  categoryTitle: "Entity Assisting a Tax-Exempt Entity",
  selected: false,
  modalResponded: null,
  requiredCount: 4,
  questions: [
    {
      id: 1,
      title: `<span>The entity operates exclusively to provide financial assistance to, or hold governance rights over, any tax-exempt entity described by <a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2011-title26/pdf/USCODE-2011-title26.pdf">Exemption #19</a>.</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is a United States person as defined in section <a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2022-title8/pdf/USCODE-2022-title8-chap12-subchapI-sec1101.pdf">7701(a)(30)</a> of the Internal Revenue Code of 1986.</span>`,
      selection: null,
    },
    {
      id: 3,
      title: `The entity is beneficially owned or controlled exclusively by one or more United States persons that are United States citizens or lawfully admitted for permanent residence. “Lawfully admitted for permanent residence” is defined in section 101(a) of the Immigration and Nationality Act (8 U.S.C. 1101(a)).`,
      selection: null,
    },
    {
      id: 4,
      title: `The entity derives at least a majority of its funding or revenue from one or more United States persons that are United States citizens or lawfully admitted for permanent residence.`,
      selection: null,
    },
  ],
};

const cat8 = {
  categoryId: 8,
  categoryTitle: "Subsidiary of Certain Exempt Entities",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `The entity’s ownership interests are controlled or wholly owned, directly or indirectly, by any of these types of exempt entities:`,
      points: [
        `Securities Reporting Issuer, as defined in Exemption #1`,
        `Governmental Authority, as defined in Exemption #2`,
        `Bank, as defined in Exemption #3`,
        `Credit Union, as defined in Exemption #4`,
        `Depository Institution Holding Company, as defined in Exemption #5`,
        `Broker or Dealer in Securities, as defined in Exemption #7`,
        `Securities Exchange or Clearing Agency, as defined in Exemption #8`,
        `Other Exchange Act Registered Entity, as defined in Exemption #9`,
        `Investment Company or Investment Adviser, as defined in Exemption #10`,
        `Venture Capital Fund Adviser, as defined in Exemption #11`,
        `Insurance Company, as defined in Exemption #12`,
        `State-Licensed Insurance Producer, as defined in Exemption #13`,
        `Commodity Exchange Act Registered Entity, as defined in Exemption #14`,
        `Accounting Firm, as defined in Exemption #15`,
        `Public Utility, as defined in Exemption #16`,
        `Financial Market Utility, as defined in Exemption #17`,
        `Tax-Exempt Entity, as defined in Exemption #19`,
        `or Large Operating Company, as defined in Exemption #21`,
      ],
      selection: null,
    },
  ],
};

const cat9 = {
  categoryId: 9,
  categoryTitle: "Depository Institution Holding Company",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is a “bank holding company” as defined in section 2 of the Bank Holding Company Act of 1956 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title12/pdf/USCODE-2021-title12-chap17-sec1841.pdf">12 U.S.C. 1841</a>).</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is a “savings and loan holding company” as defined in section 10(a) of the Home Owners’ Loan Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title12/pdf/USCODE-2021-title12-chap12-sec1467a.pdf">12 U.S.C. 1467a(a)</a>).</span>`,
      selection: null,
    },
  ],
};

const cat10 = {
  categoryId: 10,
  categoryTitle: "Bank",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is a “bank” as defined in section 3 of the Federal Deposit Insurance Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title12/pdf/USCODE-2021-title12-chap16-sec1813.pdf">12 U.S.C. 1813</a>).</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is a “bank” as defined in section 2(a) of the Investment Company Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapI-sec80a-2.pdf">15 U.S.C. 80a-2(a)</a>).</span>`,
      selection: null,
    },
    {
      id: 3,
      title: `<span>The entity is a “bank” as defined in section 202(a) of the Investment Advisers Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapII-sec80b-2.pdf">15 U.S.C. 80b-2(a)</a>).</span>`,
      selection: null,
    },
  ],
};

const cat11 = {
  categoryId: 11,
  categoryTitle: "Credit Union",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is a “Federal credit union” as defined in section 101 of the Federal Credit Union Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title12/pdf/USCODE-2021-title12-chap14-subchapI-sec1752.pdf">12 U.S.C. 1752</a>).</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is a “State credit union” as defined in section 101 of the Federal Credit Union Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title12/pdf/USCODE-2021-title12-chap14-subchapI-sec1752.pdf">12 U.S.C. 1752</a>).</span>`,
      selection: null,
    },
  ],
};

const cat12 = {
  categoryId: 12,
  categoryTitle: "Money Services Business",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is a money transmitting business registered with FinCEN under <a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title31/pdf/USCODE-2021-title31-subtitleIV-chap53-subchapII-sec5330.pdf">31 U.S.C. 5330</a>.</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is a money services business registered with FinCEN under <a target="_blank" href="https://www.ecfr.gov/current/title-31/subtitle-B/chapter-X/part-1022/subpart-C/section-1022.380">31 CFR 1022.380.</a></span>`,
      selection: null,
    },
  ],
};

const cat13 = {
  categoryId: 13,
  categoryTitle: "Broker or Dealer in Securities",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 1,
      title: `<span>The entity is a “broker” or “dealer,” as those terms are defined in section 3 of the Securities Exchange Act of 1934 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2B-sec78c.pdf">15 U.S.C. 78c</a>).</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is registered under section 15 of the Securities Exchange Act of 1934 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2B-sec78o.pdf">15 U.S.C. 78o</a>).</span>`,
      selection: null,
    },
  ],
};

const cat14 = {
  categoryId: 14,
  categoryTitle: "Securities Exchange or Clearing Agency",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 1,
      title: `<span>The entity is an “exchange” or “clearing agency,” as those terms are defined in section 3 of the Securities Exchange Act of 1934 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2B-sec78c.pdf">15 U.S.C. 78c</a>).</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is registered under sections 6 or 17A of the Securities Exchange Act of 1934 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2B-sec78f.pdf">15 U.S.C. 78f, 78q-1</a>).</span>`,
      selection: null,
    },
  ],
};

const cat15 = {
  categoryId: 15,
  categoryTitle: "Other Exchange Act Registered Entity",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 1,
      title: `The entity is not a securities reporting issuer as defined in Exemption #1, broker or dealer in securities as defined in Exemption #7, or securities exchange or clearing agency as defined in Exemption #8.`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is registered with the Securities and Exchange Commission under the Securities Exchange Act of 1934 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2B-sec78a.pdf">15 U.S.C. 78a et seq.</a>).</span>`,
      selection: null,
    },
  ],
};

const cat16 = {
  categoryId: 16,
  categoryTitle: "Investment Company or Investment Adviser",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 1,
      title: `The entity is an “investment company” or “investment adviser” defined as either:`,
      points: [
        `<span>An investment company in section 3 of the Investment Company Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapI-sec80a-3.pdf">15 U.S.C. 80a-3</a>);</span>`,
        `<span><b>or</b> An investment adviser in section 202 of the Investment Advisers Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapII-sec80b-2.pdf">15 U.S.C. 80b-2</a>)</span>`,
      ],

      selection: null,
    },
    {
      id: 2,
      title: `The entity is registered with the Securities and Exchange Commission under either of these authorities:`,
      points: [
        `<span>The Investment Company Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapI-sec80a-1.pdf">15 U.S.C. 80a-1 et seq.</a>);</span>`,
        `<span><b>or</b> The Investment Advisers Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapII-sec80b-1.pdf">15 U.S.C. 80b-1 et seq.</a>).</span>`,
      ],
      selection: null,
    },
  ],
};

const cat17 = {
  categoryId: 17,
  categoryTitle: "Venture Capital Fund Adviser",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 1,
      title: `<span>The entity is an investment adviser that is described in section 203(l) of the Investment Advisers Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapII-sec80b-3.pdf">15 U.S.C. 80b-3(l)</a>).</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `The entity has filed Item 10, Schedule A, and Schedule B of Part 1A of Form ADV, or any successor thereto, with the Securities and Exchange Commission.`,
      selection: null,
    },
  ],
};

const cat18 = {
  categoryId: 18,
  categoryTitle: "Commodity Exchange Act Registered Entity",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is a “registered entity” as defined in section 1a of the Commodity Exchange Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title7/pdf/USCODE-2021-title7-chap1-sec1a.pdf">7 U.S.C. 1a</a>).</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `The entity is one of these entities registered with the Commodity Futures Trading Commission under the Commodity Exchange Act:`,
      points: [
        `<span>“Futures commission merchant” as defined in section 1a of the Commodity Exchange Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title7/pdf/USCODE-2021-title7-chap1-sec1a.pdf">7 U.S.C. 1a</a>)<span>`,
        `<span>“Introducing broker” as defined in section 1a of the Commodity Exchange Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title7/pdf/USCODE-2021-title7-chap1-sec1a.pdf">7 U.S.C. 1a</a>)<span>`,
        `<span>“Swap dealer” as defined in section 1a of the Commodity Exchange Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title7/pdf/USCODE-2021-title7-chap1-sec1a.pdf">7 U.S.C. 1a</a>)<span>`,
        `<span>“Major swap participant” as defined in section 1a of the Commodity Exchange Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title7/pdf/USCODE-2021-title7-chap1-sec1a.pdf">7 U.S.C. 1a</a>)<span>`,
        `<span>“Commodity pool operator” as defined in section 1a of the Commodity Exchange Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title7/pdf/USCODE-2021-title7-chap1-sec1a.pdf">7 U.S.C. 1a</a>)<span>`,
        `<span>“Commodity trading advisor” as defined in section 1a of the Commodity Exchange Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title7/pdf/USCODE-2021-title7-chap1-sec1a.pdf">7 U.S.C. 1a</a>)<span>`,
        `<span><b>or</b> “Retail foreign exchange dealer” as described in <a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title7/pdf/USCODE-2021-title7-chap1-sec2.pdf">section 2(c)(2)(B)</a> of the Commodity Exchange Act<span>`,
      ],
      selection: null,
    },
  ],
};

const cat19 = {
  categoryId: 19,
  categoryTitle: "Public Utility",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 10,
      title: `The entity is a “regulated public utility” as defined in <a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title26/pdf/USCODE-2021-title26-subtitleF-chap79-sec7701.pdf">26 U.S.C. 7701(a)(33)(A).</a>`,
      selection: null,
    },
    {
      id: 11,
      title: `The entity provides telecommunications services, electrical power, natural gas, or water and sewer services within the United States.`,
      selection: null,
    },
  ],
};

const cat20 = {
  categoryId: 20,
  categoryTitle: "Financial Market Utility",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is a financial market utility designated by the Financial Stability Oversight Council under section 804 of the Payment, Clearing, and Settlement Supervision Act of 2010 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title12/pdf/USCODE-2021-title12-chap53-subchapIV-sec5463.pdf">12 U.S.C. 5463</a>).</span>`,
      selection: null,
    },
  ],
};

const cat21 = {
  categoryId: 21,
  categoryTitle: "Securities Reporting Issuer",
  selected: false,
  modalResponded: null,
  requiredCount: 1,
  questions: [
    {
      id: 1,
      title: `<span>The entity is an issuer of a class of securities registered under section 12 of the Securities Exchange Act of 1934 (<a href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2B-sec78l.pdf" target="_blank">15 U.S.C. 78l</a>).</span>`,
      selection: null,
    },
    {
      id: 2,
      title: `<span>The entity is required to file supplementary and periodic information under section 15(d) of the Securities Exchange Act of 1934 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2B-sec78o.pdf">15 U.S.C. 78o(d)</a>)</span>`,
      selection: null,
    },
  ],
};

const cat22 = {
  categoryId: 22,
  categoryTitle: "Governmental Authority",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 1,
      title: `The entity is established under the laws of the United States, an Indian tribe, a State, or a political subdivision of a State, or under an interstate compact between two or more States.`,
      selection: null,
    },
    {
      id: 2,
      title: `The entity exercises governmental authority on behalf of the United States or any such Indian tribe, State, or political subdivision.`,
      selection: null,
    },
  ],
};

const cat23 = {
  categoryId: 23,
  categoryTitle: "Pooled Investment Vehicle",
  selected: false,
  modalResponded: null,
  requiredCount: 2,
  questions: [
    {
      id: 1,
      title: `The entity is a pooled investment vehicle if either of these statements apply to the entity:`,
      points: [
        `<span>Is an investment company, as defined in section 3(a) of the Investment Company Act of 1940 (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapI-sec80a-3.pdf">15 U.S.C. 80a-3(a)</a>;</span>`,
        `<span><b>or</b> Is a company that would be an investment company under that section but for the exclusion provided from that definition by paragraph (1) or (7) of section 3(c) of that Act (<a target="_blank" href="https://www.govinfo.gov/content/pkg/USCODE-2021-title15/pdf/USCODE-2021-title15-chap2D-subchapI-sec80a-3.pdf">15 U.S.C. 80a-3(c)</a>); and is identified by its legal name by the applicable investment adviser in its Form ADV, (or successor form) filed with the Securities and Exchange Commission or will be so identified in the next annual updating amendment to Form ADV required to be filed by the applicable investment adviser pursuant to rule 204-1 under the Investment Advisers Act of 1940 (<a target="_blank" href="https://www.ecfr.gov/current/title-17/chapter-II/part-275/section-275.204-1">17 CFR 275.204-1</a>).<span>`,
      ],
      selection: null,
    },
    {
      id: 2,
      title: `The entity is operated or advised by any of these types of exempt entities:`,
      points: [
        `Bank, as defined in Exemption #3`,
        `Credit Union, as defined in Exemption #4`,
        `Broker or Dealer in Securities, as defined in Exemption #7`,
        `Investment Company or Investment Adviser, as defined in Exemption #10`,
        `Venture Capital Fund Adviser, as defined in Exemption #11`,
      ],
      selection: null,
    },
  ],
};

/*const cat24 = {
  categoryId: 24,
  selected: false,
  categoryTitle: "None Apply",
  questions: [],
};*/

export const filingCategories = [
  cat1,
  cat2,
  cat3,
  cat4,
  cat5,
  cat6,
  cat7,
  cat8,
  cat9,
  cat10,
  cat11,
  cat12,
  cat13,
  cat14,
  cat15,
  cat16,
  cat17,
  cat18,
  cat19,
  cat20,
  cat21,
  cat22,
  cat23,
  //cat24,
];

export const RunnerText = "Runner";

const catTemplate1 = {
  categoryId: 1,
  categoryTitle: "Large Operating Company",
  selected: false,
};

const catTemplate2 = {
  categoryId: 2,
  categoryTitle: "Inactive Entity",
  selected: false,
};

const catTemplate3 = {
  categoryId: 3,
  categoryTitle: "Accounting Firm",
  selected: false,
};

const catTemplate4 = {
  categoryId: 4,
  categoryTitle: "Insurance Company",
  selected: false,
};

const catTemplate5 = {
  categoryId: 5,
  categoryTitle: "State-Licensed Insurance Producer",
  selected: false,
};

const catTemplate6 = {
  categoryId: 6,
  categoryTitle: "Tax-Exempt Entity",
  selected: false,
};

const catTemplate7 = {
  categoryId: 7,
  categoryTitle: "Entity Assisting a Tax-Exempt Entity",
  selected: false,
};

const catTemplate8 = {
  categoryId: 8,
  categoryTitle: "Subsidiary of Certain Exempt Entities",
  selected: false,
};

const catTemplate9 = {
  categoryId: 9,
  categoryTitle: "Depository Institution Holding Company",
  selected: false,
};

const catTemplate10 = {
  categoryId: 10,
  categoryTitle: "Bank",
  selected: false,
};

const catTemplate11 = {
  categoryId: 11,
  categoryTitle: "Credit Union",
  selected: false,
};

const catTemplate12 = {
  categoryId: 12,
  categoryTitle: "Money Services Business",
  selected: false,
};

const catTemplate13 = {
  categoryId: 13,
  categoryTitle: "Broker or Dealer in Securities",
  selected: false,
};

const catTemplate14 = {
  categoryId: 14,
  categoryTitle: "Securities Exchange or Clearing Agency",
  selected: false,
};

const catTemplate15 = {
  categoryId: 15,
  categoryTitle: "Other Exchange Act Registered Entity",
  selected: false,
};

const catTemplate16 = {
  categoryId: 16,
  categoryTitle: "Investment Company or Investment Adviser",
  selected: false,
};

const catTemplate17 = {
  categoryId: 17,
  categoryTitle: "Venture Capital Fund Adviser",
  selected: false,
};

const catTemplate18 = {
  categoryId: 18,
  categoryTitle: "Commodity Exchange Act Registered Entity",
  selected: false,
};

const catTemplate19 = {
  categoryId: 19,
  categoryTitle: "Public Utility",
  selected: false,
};

const catTemplate20 = {
  categoryId: 20,
  categoryTitle: "Financial Market Utility",
  selected: false,
};

const catTemplate21 = {
  categoryId: 21,
  categoryTitle: "Securities Reporting Issuer",
  selected: false,
};

const catTemplate22 = {
  categoryId: 22,
  categoryTitle: "Governmental Authority",
  selected: false,
};

const catTemplate23 = {
  categoryId: 23,
  categoryTitle: "Pooled Investment Vehicle",
  selected: false,
};

/*const catTemplate24 = {
  categoryId: 24,
  selected: false,
  categoryTitle: "None Apply",
  questions: [],
};*/

export const filingCategoriesTemplates = [
  catTemplate1,
  catTemplate2,
  catTemplate3,
  catTemplate4,
  catTemplate5,
  catTemplate6,
  catTemplate7,
  catTemplate8,
  catTemplate9,
  catTemplate10,
  catTemplate11,
  catTemplate12,
  catTemplate13,
  catTemplate14,
  catTemplate15,
  catTemplate16,
  catTemplate17,
  catTemplate18,
  catTemplate19,
  catTemplate20,
  catTemplate21,
  catTemplate22,
  catTemplate23,
  //catTemplate24,
];
